export default {"src":"/_next/static/media/RL.81c9cef4.svg","height":18,"width":18};